module.exports = __webpack_public_path__ + "static/img/menu.9f241a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/menu.png
// module id = 8wfO
// module chunks = 6